function Dummy() {
  return (
    <div className="dummy">
      <p>Innum onnum pannala :( Pannuvom.....</p>
    
      <br />
      <br />
      <p>
        <div className="hidden">
          <ul>
            <li>
              {" "}
              <a href="/resume">Resume</a>
            </li>
            <li>
              {" "}
              <a href="/tollList">TollList</a>
            </li>
            <li>
              {" "}
              <a href="/vehicleLogs">VehicleLogs</a>
            </li>
            <li>
              {" "}
              <a href="/expenseTracker">ExpenseTracker</a>
            </li>
            <li>
              {" "}
              <a href="/awsAPIandLambda">awsAPIandLambda</a>
            </li>
            <li>
              {" "}
              <a href="/awsS3TextFile">awsS3TextFile</a>
            </li>
            <li>
              {" "}
              <a href="/sendingAPIrequest">sendingAPIrequest</a>
            </li>
            <li>
              {" "}
              <a href="/processingAPIrequest">processingAPIrequest</a>
            </li>
            <li>
              {" "}
              <a
                href="http://sample-static-website-aviii.s3-website.ap-south-1.amazonaws.com/"
                target="blank"
              >
                S3StaticWebpage
              </a>
            </li>
            <li>
              {" "}
              <a href="/s3StaticWebpage">S3StaticWebpage-insecure</a>
            </li>
            <li>
              {" "}
              <a href="/miniGames">miniGames</a>
            </li>
            <li>
              {" "}
              <a href="https://html-css-udemy.netlify.app/" target="blank">html-css-udemy</a>
            </li>
            <li>
              {" "}
              <a href="/threeRadio">ThreeRadio</a>
            </li>
            <li>
              {" "}
              <a href="/flowDiagram">FlowDiagram</a>
            </li>
          </ul>
        </div>
      </p>
    </div>
  );
}

export default Dummy;
